export default "__VITE_ASSET__LVxWVRwW__"